import { render, staticRenderFns } from "./trash-paper-popup.html?vue&type=template&id=551c15ec&scoped=true&external"
import script from "./trash-paper-popup.js?vue&type=script&lang=js&external"
export * from "./trash-paper-popup.js?vue&type=script&lang=js&external"
import style0 from "./trash-paper-popup.scss?vue&type=style&index=0&id=551c15ec&prod&scoped=true&lang=scss&external"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "551c15ec",
  null
  
)

export default component.exports